import { RouteRecordRaw } from "vue-router";

const schoolAdminRoutes: RouteRecordRaw[] = [
  {
    path: "/school-admin/teachers",
    component: () => import("../views/school-admin/TeacherAdminView.vue"),
  },
  {
    path: "/school-admin/students",
    component: () => import("../views/school-admin/StudentAdminView.vue"),
  },
  {
    path: "/school-admin/old-students",
    component: () => import("../views/school-admin/OldStudentsAdminView.vue"),
  },
  {
    path: "/school-admin/class/students/:classId/:section?",
    component: () => import("../views/school-admin/ClassStudentsAdminView.vue"),
  },
  {
    path: "/school-admin/class/tests/:classId",
    component: () => import("../views/school-admin/ClassTestsAdminView.vue"),
  },
  {
    path: "/school-admin/class/stats/:classId",
    component: () => import("../views/school-admin/ClassStatsView.vue"),
  },
  {
    path: "/school-admin/word-lists",
    component: () => import("../views/school-admin/SchoolWordListsView.vue"),
  },
  {
    path: "/school-admin/student-teams",
    redirect: "/school-admin/student-teams/spelling",
  },
  {
    path: "/school-admin/student-teams/:subject",
    component: () => import("../views/school-admin/TeamsAdminView.vue"),
  },
];

export default schoolAdminRoutes;
